import { Input, OnDestroy, OnInit } from '@angular/core';
import { Wizard } from '../wizard.class';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { InjectorService } from 'src/app/shared/services/injector/injector.service';
import { Subscription } from 'rxjs';
import { EActions } from '../../enums/actions.enum';
import { AnalyticsService } from 'src/app/shared/services/analytics/analytics.service';

export class Step implements OnInit, OnDestroy {
  @Input() wizard: Wizard;

  public config: ConfigService;
  public subscribers: Subscription[];
  public analyticsService: AnalyticsService;

  constructor() {
    Object.assign(this, {
      config: InjectorService.get().get(ConfigService),
      analyticsService: InjectorService.get().get(AnalyticsService),
      subscribers: []
    });
  }

  public ngOnInit(): void {
    this.actionsSubscriber();
  }

  public ngOnDestroy(): void {
    this.unsubscribe();
  }

  public trySafety(action: () => void): void {
    try {
      action();
    } catch (err) {
      this.wizard.goHome();
    }
  }

  public toggleBackStepState(s: EActions): void {
    this.wizard.actions.next(s);
  }

  private actionsSubscriber(): void {
    this.subscribers.push(this.wizard.actions.asObservable().subscribe((a) => (typeof this[a] === 'function') && this[a]()));
  }

  private unsubscribe(): void {
    this.subscribers.forEach((s) => s.unsubscribe());
  }
}
